import { createStyles } from "@mantine/emotion";

import { getBarHeight }     from "_common/utils";
import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( theme => {
	const barHeight = getBarHeight ();

	return {
		container: {
			height   : "100%",
			// position : "relative",
			overflow : "scroll"
		},
		fanTooltip: {
			fontSize: "13px"
		},
		creatorCardContainer: {
			padding         : "1rem",
			overflow        : "hidden auto",
			width           : "100%",
			height          : theme.other.isMobile ? `calc((100vh - 56.25vw) - 120px - ${ barHeight }px )` : "100%",
			backgroundColor : theme.other.isMobile ? theme.other.paletteNew.secondaryBlack : "inherit",

			[rooterMediaQuery.mobileAndTablet]: {
				backgroundColor: theme.other.colors.dialog.secondary
			}

		},
		creatorCard: {
			display      : "flex",
			alignItems   : "center",
			borderRadius : "5px",
			// padding      : "1rem 0.5rem",
			marginBottom : "1.5rem",
			position     : "relative"
		},
		creatorCardLeft: {
			marginRight: "0.5rem"
		},
		subCaptionText: {
			color      : "rgba(232,233,240, 0.82)",
			fontWeight : "500"
		},
		creatorCardRight: {
			position       : "absolute",
			height         : "100%",
			display        : "flex",
			flexDirection  : "column",
			right          : "0px",
			justifyContent : "center",
			width          : "60%"
		},
		currentUserFanRank: {
			backgroundImage : "linear-gradient(97deg, #126bd5 3%, #439aff 97%)",
			position        : "absolute",
			bottom          : 0,
			width           : "100%",
			padding         : "0 1rem",
			zIndex          : 10
		},
		svgIcon: {
			height : "60px",
			width  : "60px"
		},
		svgIconInfo: {
			height    : "30px",
			width     : "30px",
			cursor    : "pointer",
			transform : "scale(0.8)"
		},
		svgIconRefresh: {
			height : "2rem",
			width  : "2rem"
		},
		svgIconRefreshDark: {
			filter    : "invert(1)",
			transform : "scale(0.9)"
		},
		endedView: {
			display             : "grid",
			gridTemplateColumns : "1fr 1fr 1fr",
			gridColumnGap       : "1rem"
		},
		refreshButton: {
			cursor  : "pointer",
			padding : "1.2rem"
		// "&>svg"  : {
		// ...theme.other.svgIcons.size20
		// }
		},
		fanRankIcons: {
			display        : "flex",
			justifyContent : "right",
			alignItems     : "flex-end",
			marginTop      : "-1.3rem",
			marginBottom   : "0.3rem",

			[rooterMediaQuery.mobile]: {
				display: "none"
			}
		},
		giveAwayText: {
			fontWeight : "500",
			fontSize   : "1.1rem"
		},
		emptyfanRank: {
			textAlign: "center"
		},
		emptyfanRankText: {
			color      : "#757575",
			fontSize   : "13px",
			fontWeight : "normal"
		},
		coinAmt: {
			color      : "#fcc62d",
			fontWeight : "500",
			fontSize   : "2.3rem"
		},
		coinSvg: {
			width       : "25px",
			height      : "25px",
			marginRight : "0.4em"
		},
		giveAwayStyles: {
			display    : "flex",
			alignItems : "center"
		}
	};
} );
